import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { AutocompleteComponent } from '@valk-nx/components/ui-autocomplete/src/lib/autocomplete';
import type { DropdownOption } from '@valk-nx/components/ui-select-shell/src/lib/select-shell.interface';
import { MINIMUM_QUERY_LENGTH } from '@valk-nx/services/location-search/src/lib/location-search.service';

@Component({
	selector: `vp-filter-search`,
	templateUrl: './filter-search.html',
	imports: [TranslatePipe, AutocompleteComponent],
})
export class FilterSearchComponent {
	protected readonly minimumCharacters = MINIMUM_QUERY_LENGTH;

	options = input.required<DropdownOption[]>();
	loading = input<boolean>(false);

	searched = output<string>();
	selected = output<string>();

	onSearched(term: string): void {
		this.searched.emit(term);
	}

	onSelected(value: string): void {
		this.selected.emit(value);
	}
}
